export default __webpack_public_path__ + "static/media/map.445b5721.png";